import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/facebookPixel';

const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view when route changes
    trackPageView();
  }, [location]);

  return null; // This component doesn't render anything
};

export default RouteTracker;
